import React, {useEffect} from "react";
import {divIcon} from "leaflet";
import {
    MapContainer as LeafletMap,
    TileLayer,
    WMSTileLayer,
    Marker,
    Tooltip,
    ScaleControl,
    ZoomControl,
    GeoJSON,
    useMap,
} from "react-leaflet";
import styled from "styled-components";

import "./MapContainer.css";
import KOREA_MAP from "../data/map/KOREA-MAP-V3.json";
import {MAP_URLS} from "../data/basicStructure";

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
`;

function ChangeView({center, zoom}) {
    const map = useMap();
    useEffect(() => {
        map.setView(center, zoom);
    }, [center[0], center[1], zoom]);
    return null;
}

const MapContainer = (props) => {
    const {
        targetProvince,
        totalSpots,
        selectedFbOption,
        selectSpot,
        selectedStationType,
    } = props;

    const center =
        targetProvince && targetProvince.center
            ? [targetProvince.center.lat, targetProvince.center.lon]
            : [35.9078, 128.0];
    const zoom = targetProvince && targetProvince.zoom ? targetProvince.zoom : 7;

    const onEachFeature = (feature, layer) => {
        layer.on({
            mouseover: () => {
            },
            mouseout: () => {
            },
            click: () => {
            },
        });
    };

    return (
        <Wrapper>
            <LeafletMap
                center={center}
                zoom={zoom}
                minZoom={7}
                style={{width: "100%", height: "100%"}}
                zoomControl={false}
            >
                <ChangeView center={center} zoom={zoom}/>
                <ZoomControl position="bottomleft"/>
                <ScaleControl metric={true} imperial={false}/>
                <TileLayer url={MAP_URLS.satellite} attribution="VWORLD"/>
                <WMSTileLayer url={MAP_URLS.hybrid}/>
                {selectedFbOption && totalSpots && selectedStationType
                    ? totalSpots
                        .filter((item) => {
                            if (selectedStationType.id == 1) {
                                return true;
                            } else {
                                return selectedStationType.typeName == item.stationType;
                            }
                        })
                        .map((spot) => (
                            <Marker
                                eventHandlers={{
                                    click: () => {
                                        selectSpot(spot);
                                    },
                                }}
                                key={spot.id}
                                position={[spot["lat"], spot["lon"]]}
                                icon={divIcon({
                                    className: "",
                                    iconSize: [24, 24],
                                    html: `<div style="background:${
                                        spot[selectedFbOption.title]["color"]
                                            ? spot[selectedFbOption.title]["color"]
                                            : "white"
                                    }; opacity: 0.8; height:24px; border-radius:50%;"><div/>`,
                                })}
                            >
                                <Tooltip>{`${spot.stationName ? spot.stationName : "-"}(${
                                    spot.stationCode ? spot.stationCode : "-"
                                }: ${spot.stationType ? spot.stationType : "-"})`}</Tooltip>
                            </Marker>
                        ))
                    : null}
                <GeoJSON
                    color={"black"}
                    weight={2}
                    opacity={0.5}
                    fillColor={"white"}
                    data={KOREA_MAP}
                    onEachFeature={onEachFeature}
                />
            </LeafletMap>
        </Wrapper>
    );
};

export default MapContainer;
